function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Radio, InputNumber, Upload, Tabs, Image, Divider, Select, List } from "antd";
import { Table, Container, Row, Col } from "react-bootstrap";
import { GeoAltFill, TelephoneFill, PersonFill, BoxFill, EnvelopeCheckFill, HandIndexFill, ArrowClockwise, CameraFill, Upload as UploadIc, Paperclip, Link } from "react-bootstrap-icons";
import Common from "../includes/Common";
import Webcam from "react-webcam";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var EditAssignDeliveryPerson = function EditAssignDeliveryPerson(_ref) {
  var order = _ref.order,
    handler = _ref.handler;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    successMessage = _useState4[0],
    setSuccessMessage = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFormProcessing = _useState6[0],
    setIsFormProcessing = _useState6[1];
  var _useState7 = useState(1),
    _useState8 = _slicedToArray(_useState7, 2),
    fileType = _useState8[0],
    setFileType = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    file = _useState0[0],
    setFile = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    userOptions = _useState10[0],
    setUserOptions = _useState10[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    },
    accept: ".pdf",
    maxCount: 1
  };
  var handleFileTabChange = function handleFileTabChange(key) {
    setFileType(key);
  };
  var onFinish = function onFinish(values) {
    var fData = new FormData();
    fData.append("delivery_user_id", values.delivery_user_id);
    fData.append("purchase_order_id", order.id);
    fData.append("user_id", Common.currentUser.id);
    setIsFormProcessing(true);
    setSuccessMessage("");
    setErrorMessage("");
    axios.post(Common.baseApiUrl + "editassignorder", fData).then(function (response) {
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue " + error.toString());
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      delivery_user_id: order.delivery_user_id
    });
  }, []);
  useEffect(function () {
    axios.get(Common.baseApiUrl + "getfreedeliverypeople/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        response.data.users.forEach(function (u) {
          setUserOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: u.prenom + " " + u.nom,
              value: u.id
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue ' + error.toString(),
        delay: 5
      });
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        lg: 7,
        md: 8,
        sm: 9,
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            marginTop: "8px",
            padding: "6px",
            border: "1px dashed #4987b0",
            borderRadius: "8px"
          },
          children: [/*#__PURE__*/_jsx("h6", {
            children: /*#__PURE__*/_jsxs("b", {
              children: ["Commande client - ", order.customer && order.customer.name]
            })
          }), /*#__PURE__*/_jsx(List, {
            dataSource: order.purchase_order_items,
            itemLayout: "vertical",
            size: "small",
            renderItem: function renderItem(item, index) {
              return /*#__PURE__*/_jsx(List.Item, {
                children: /*#__PURE__*/_jsx(List.Item.Meta, {
                  avatar: /*#__PURE__*/_jsx(BoxFill, {
                    size: 15
                  }),
                  title: /*#__PURE__*/_jsxs("span", {
                    style: {
                      fontSize: "14px"
                    },
                    children: [item.label, " | Qte: ", item.quantity, ", P.U: ", item.price.toLocaleString("Fr")]
                  })
                })
              });
            }
          })]
        })
      }), /*#__PURE__*/_jsx(Col, {
        children: /*#__PURE__*/_jsx("div", {
          style: {
            textAlign: "center"
          },
          children: /*#__PURE__*/_jsx(Image, {
            src: "drawables/dlg.png",
            preview: false,
            width: "95%"
          })
        })
      })]
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Form, {
      size: "large",
      onFinish: onFinish,
      layout: "vertical",
      form: form,
      children: [(errorMessage.length > 0 || successMessage.length > 0) && /*#__PURE__*/_jsxs(Form.Item, {
        children: [successMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
          type: "success",
          message: successMessage,
          banner: true
        }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage,
          banner: true
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "delivery_user_id",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        label: "Livreur",
        children: /*#__PURE__*/_jsx(Select, {
          options: userOptions
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormProcessing,
          icon: /*#__PURE__*/_jsx(Link, {}),
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: " Changer"
          })
        })
      })]
    })]
  });
};
export default EditAssignDeliveryPerson;